
import MenuLeft from './menuleft';


import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Profile from './profile';
import MessagesContent from './MessagesContent';
import Children from './Сhildren';
import CabinetChildrenList from './components/CabinetChildrenCard/CabinetChildrenList';
import ApplicationWizard from './wizzard';
import FAQ from './FAQ';
import ApplicationsPage from './Application';

import ProfilePage from './components/ProfilePage/ProfilePage';

import WizPlain from './wizplain';

import { getEmptyData } from './wizplain/data/emptyform';

import { convertReqToForm } from './wizplain/helpers/convReqToForm';

//import Wizard from './wizardgpt';

import './ProfilePage.css';
import Wizard from './wizplain';

const STATE_CABINET = 'statecabinet';
const STATE_WIZARD_TEMP = 'cabinetwizardtemp';
const STATE_WIZARD_STEP = 'cabinetwizardstep';
const STATE_WIZARD_ISEDIT = 'cabinetwizardisedit';


const CabinetPage = (props) => {

  const wizPersistentData = localStorage.getItem(STATE_WIZARD_TEMP);
  const stepPersistentData = localStorage.getItem(STATE_WIZARD_STEP);
  const isEditPersistentData = localStorage.getItem(STATE_WIZARD_ISEDIT);
  
  

  const [activeView, setPart ] = useState(localStorage.getItem(STATE_CABINET) || 'applications_act');
  const [prevPart, setPrev] = useState('applications');
  const [dataEdit, setDataEdit] = useState(wizPersistentData && JSON.parse(wizPersistentData) || getEmptyData());
  const [isEdit, setIsEdit] = useState(isEditPersistentData == "true" || false);
  const [dictionaryAddress, setDictionary] = useState({});


  
  


  useEffect(()=>{ localStorage.setItem(STATE_CABINET, activeView)}, [activeView]);

  useEffect(()=>{ localStorage.setItem(STATE_WIZARD_ISEDIT, isEdit) },[isEdit]);


  const clearStorage = ()=>{
    localStorage.removeItem(STATE_WIZARD_STEP);
    localStorage.removeItem(STATE_WIZARD_TEMP);
    localStorage.removeItem(STATE_WIZARD_ISEDIT);
  }

  const onMenuItemClick = (part) =>{
    if(activeView == 'wizzard') return alert(`Спочатку завершить роботу з відкритою формою анкети.`);
    setPart(part);
  }


  const onEditApplication = ({info}) => {
    const _info = convertReqToForm(info);
    setDataEdit(_info);
    setDictionary(info.dictionary && JSON.parse(info.dictionary) || {});
    setIsEdit(true);
    setPrev(activeView);
    setPart('wizzard');
  };

  const onNewApplication = ()=>{

    if(activeView == 'wizzard') return alert(`Спочатку завершить роботу з вже відкритою формою анкети.`)

    clearStorage();
    setDataEdit(getEmptyData());
    setDictionary({});
    setIsEdit(false);
    setPrev(activeView);
    setPart('wizzard');
  }

  const onFinishApplication = ()=>{

    setDataEdit(getEmptyData());
    setDictionary({});
    setIsEdit(false);
    clearStorage();
    setPart(prevPart);
  }


  const setPersDataForm = (data)=>{
    localStorage.setItem(STATE_WIZARD_TEMP, JSON.stringify(data))
  }

  const setPersStep = (step)=>{
    localStorage.setItem(STATE_WIZARD_STEP, step)
  }



  const renderChildrenComponent = () => {
          switch (activeView) {
          case 'profile':
            return <ProfilePage />;
          case 'messages':
            return <MessagesContent />;
          case 'children':
            return <CabinetChildrenList />;
          case 'wizzard':
            return <WizPlain 
              onFinish={onFinishApplication} 
              isEdit={isEdit} 
              data={dataEdit} 
              dictionary={dictionaryAddress}
              step={stepPersistentData ? +stepPersistentData : 1}
              setPersData={setPersDataForm}
              setPersStep={setPersStep} 
              />;    
          case 'faq':
            return <FAQ />      
          case 'applications':
          case 'applications_act':
            return <ApplicationsPage onEdit={onEditApplication} type="actual"/>;
          case 'applications_closed':
            return <ApplicationsPage onEdit={onEditApplication} type="final"/>;
           case 'applications_removed':
            return <ApplicationsPage onEdit={onEditApplication} type="archive"/>;
          default:
            return null; // Or a default component
        }
  }


  return (
    <div className="profile-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Left Sidebar */}
            <Col md={3} className="sidebar">
                <MenuLeft onMenuItemClick={onMenuItemClick} onNewApplication={onNewApplication} activeItem={activeView}/>
            </Col>
            
            {/* Main Content */}
            <Col md={9} className="main-content-area">
             {renderChildrenComponent()}
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
};

export default CabinetPage;